import * as React from "react";
import { notifyNativeOtpRequested } from "../lib/bridge";
import { subscribeNativeOtp } from "../lib/bridge/handleOtp";

/** AOS SMS receiver 유효 시간과 맞춘다. */
const OTP_LISTEN_TTL_MS = 5 * 60 * 1000;

/**
 * 인증번호 발급 요청 시 네이티브에 SMS 수신을 알리고,
 * AOS가 handleOtp로 넘긴 번호를 입력란에 채운다.
 */
export function useNativeOtpAutofill(onOtp: (otp: string) => void) {
  const requestedAtRef = React.useRef<number | null>(null);
  const onOtpRef = React.useRef(onOtp);
  onOtpRef.current = onOtp;

  React.useEffect(() => {
    return subscribeNativeOtp((otp) => {
      const requestedAt = requestedAtRef.current;
      if (requestedAt == null) return;
      if (Date.now() - requestedAt > OTP_LISTEN_TTL_MS) return;
      onOtpRef.current(otp);
    });
  }, []);

  const startListen = React.useCallback(() => {
    requestedAtRef.current = Date.now();
    notifyNativeOtpRequested();
  }, []);

  return { startListen };
}
